import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "type", "logos"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { BREAKPOINTS } from "../../constants/design";
import { IMAGE_LOADING, IMAGE_DECODING, IMAGE_FETCHPRIORITY } from "../../constants/image";
import { isVRT } from "../../util/vrt";
import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useInterval, useMedia } from 'react-use';
import { Carousel, useCarousel } from "../copenhagen-carousel";
import { Container, Row, Image, LogoContainer, Name, CarouselContainer, StyledHeadlineAndText } from "./logos-module.styles";
import { getLayoutByType, LAYOUT_TYPE } from "./constants";
import Logo from "./logo";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var defaultLayoutType = LAYOUT_TYPE.integrations;
var USE_MEDIA_DEFAULT_STATE = false;
/**
 * @deprecated
 * This module has been migrated to the Public Main Site
 * @see: https://github.com/Typeform/public-main-site/blob/main/components/modules/logos-module/logos-module.tsx
 */
var LogosModule = function LogosModule(_ref) {
  var title = _ref.title,
    type = _ref.type,
    logos = _ref.logos,
    rest = _objectWithoutProperties(_ref, _excluded);
  var carousel = useCarousel({
    isInfinite: true,
    totalPages: logos.length
  });
  var isMobileWidth = useMedia("(max-width: ".concat(BREAKPOINTS.sm - 1, "px)"), USE_MEDIA_DEFAULT_STATE);
  var isMobile = typeof window !== 'undefined' && isMobileWidth;
  var showName = type === LAYOUT_TYPE.integrations;
  var goToNextLogo = useCallback(function () {
    carousel.goToNextIndex();
  }, [carousel]);
  useInterval(function () {
    goToNextLogo();
  }, isVRT ? null : 1500);
  var _getLayoutByType = getLayoutByType(type),
    width = _getLayoutByType.width,
    height = _getLayoutByType.height;
  return /*#__PURE__*/_jsxs(Container, _objectSpread(_objectSpread({
    as: "section"
  }, rest), {}, {
    children: [title && /*#__PURE__*/_jsx(StyledHeadlineAndText, {
      title: title,
      titleSize: type === LAYOUT_TYPE.compact ? 1 : 2
    }), isMobile && /*#__PURE__*/_jsx(CarouselContainer, {
      children: /*#__PURE__*/_jsx(Carousel, {
        gap: "64px",
        hook: carousel,
        touch: false,
        children: logos.map(function (_ref2, index) {
          var name = _ref2.name,
            url = _ref2.url,
            image = _ref2.image;
          return /*#__PURE__*/_jsx(Logo, {
            height: height,
            index: index,
            name: name,
            showName: showName,
            url: url || image.url,
            width: width
          }, "logo-".concat(index));
        })
      })
    }), !isMobile && /*#__PURE__*/_jsx(Row, {
      children: logos.map(function (_ref3, index) {
        var name = _ref3.name,
          url = _ref3.url,
          image = _ref3.image;
        return /*#__PURE__*/_jsxs(LogoContainer, {
          children: [/*#__PURE__*/_jsx(Image, {
            height: height,
            alt: name,
            src: url || image.url
          }), showName && /*#__PURE__*/_jsx(Name, {
            children: name
          })]
        }, "logo-".concat(index));
      })
    })]
  }));
};
LogosModule.displayName = 'LogosModule';
LogosModule.propTypes = {
  title: PropTypes.string,
  type: PropTypes.oneOf(Object.values(LAYOUT_TYPE)),
  logos: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    url: PropTypes.string,
    image: PropTypes.shape({
      url: PropTypes.string.isRequired
    }),
    loading: PropTypes.oneOf(Object.values(IMAGE_LOADING)),
    decoding: PropTypes.oneOf(Object.values(IMAGE_DECODING)),
    fetchpriority: PropTypes.oneOf(Object.values(IMAGE_FETCHPRIORITY))
  }))
};
LogosModule.defaultProps = {
  title: '',
  logos: [],
  type: defaultLayoutType
};
export default /*#__PURE__*/memo(LogosModule);